import { create } from "./create"

const themes = {
  create,
}
export default themes
